module.exports = __webpack_public_path__ + "static/media/67718106-E4AA-491E-891D-5A1F4B4C0E5C.a3cc68e2.jpeg";